var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnxiety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:#5e6175;}.cls-3{fill:#e1830e;}.cls-4{fill:#a9afc4;}.cls-5,.cls-8{mix-blend-mode:multiply;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#dee1ec;}.cls-7{fill:#f5f5f5;}.cls-8{fill:url(#linear-gradient-2);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 260.69,
    y1: 353.39,
    x2: 260.69,
    y2: 623.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cacfdd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eef0f1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 259.83,
    y1: 262.27,
    x2: 259.83,
    y2: 396.25,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Anxiety") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Anxiety"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.41,116.88h0a12.35,12.35,0,1,1,12.47-12.23A12.33,12.33,0,0,1,51.41,116.88Zm.06-6a6.35,6.35,0,1,0-6.28-6.4A6.36,6.36,0,0,0,51.47,110.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.43,61.6a9.41,9.41,0,0,1-6.77-2.84,9.49,9.49,0,1,1,6.77,2.84Zm0-13a3.49,3.49,0,1,0,2.48,1A3.44,3.44,0,0,0,95.44,48.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M427.83,475.46V389.75A69,69,0,0,0,384,325.49l-76.63-32.16h-94l-76.64,32.16a69,69,0,0,0-43.86,64.26v85.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M427.83,475.46V389.75A69,69,0,0,0,384,325.49l-76.63-32.16h-94l-76.64,32.16a69,69,0,0,0-43.86,64.26v85.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M427.83,389.74v85.72h-335V389.74a69,69,0,0,1,43.86-64.24c68.32-28.68,52.38-22,76.64-32.16h94L384,325.5A69,69,0,0,1,427.83,389.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M427.83,389.75v85.71h-335V389.75a69,69,0,0,1,43.87-64.25l76.64-32.16h94L384,325.5A69,69,0,0,1,427.83,389.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M388.53,475.46H282.82L260.9,407.58l-21.3,67.88H132.86l65.25-112.83-8.26-8.39a30.5,30.5,0,0,1-8.79-21.53V306.87l32.27-13.53h94l33,13.84v25.53a30.55,30.55,0,0,1-8.79,21.53l-8.26,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M303.74,293.34a37.4,37.4,0,0,1-37.36,37.36H254.3a37.41,37.41,0,0,1-37.37-37.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M323.47,300.1c-3.82,29.77-27,50.6-57.09,50.6H254.3c-30.15,0-53.23-20.85-57.07-50.61l16.1-6.75h3.6A37.41,37.41,0,0,0,254.3,330.7h12.08a37.4,37.4,0,0,0,37.36-37.36h3.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.38,353.7H254.3c-31.31,0-56-21.89-60.05-53.23l-.29-2.26,18.77-7.87h7.2v3A34.4,34.4,0,0,0,254.3,327.7h12.08a34.39,34.39,0,0,0,34.36-34.36v-3h7.2l18.8,7.88-.3,2.26C322.42,331.82,297.72,353.7,266.38,353.7ZM200.54,302c4.47,27.11,25.92,45.74,53.76,45.74h12.08c28,0,49.34-18.75,53.78-45.73l-13.53-5.63a40.42,40.42,0,0,1-40.25,37.36H254.3A40.42,40.42,0,0,1,214,296.34C213.88,296.34,215,295.9,200.54,302Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M266.38,333.7H254.3a40.41,40.41,0,0,1-40.37-40.36v-3h92.81v3A40.41,40.41,0,0,1,266.38,333.7Zm-46.32-37.36A34.41,34.41,0,0,0,254.3,327.7h12.08a34.4,34.4,0,0,0,34.23-31.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M95.83,475.46h-6V389.74a72.48,72.48,0,0,1,45.76-67.05l77.14-32.37h46.89v6H213.94l-76.1,31.93a66.48,66.48,0,0,0-42,61.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M321,299.05a86.41,86.41,0,0,1-122.28.42l14.65-6.13h94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M430.83,475.46h-6V389.74a66.44,66.44,0,0,0-41.95-61.46l-76.14-32h-92.8l-76.09,31.93a66.47,66.47,0,0,0-42,61.49v85.72h-6V389.74a72.48,72.48,0,0,1,45.77-67.05l77.13-32.37h95.21l77.19,32.4a72.45,72.45,0,0,1,45.7,67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.39,311.63a74.77,74.77,0,0,1-74.78-74.77V199.34a74.78,74.78,0,0,1,149.55,0v37.52A74.77,74.77,0,0,1,260.39,311.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M260.39,314.63a77.86,77.86,0,0,1-77.78-77.77V199.34a77.78,77.78,0,1,1,155.55,0v37.52A77.86,77.86,0,0,1,260.39,314.63Zm0-187.07a71.86,71.86,0,0,0-71.78,71.78v37.52a71.78,71.78,0,0,0,143.55,0V199.34A71.86,71.86,0,0,0,260.39,127.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351.37,215.13v10.53a15.82,15.82,0,0,1-4.65,11.23L341.66,242a15.85,15.85,0,0,1-6.64,4c.21-3.33.15-1.51.15-46.71A15.89,15.89,0,0,1,351.37,215.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M185.76,245.9a15.83,15.83,0,0,1-6.53-3.93l-5.06-5.08a15.83,15.83,0,0,1-4.66-11.23V215.13a15.9,15.9,0,0,1,16.1-15.91C185.61,245.06,185.56,242.79,185.76,245.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M331.75,250c.56-8.72.42-.45.42-53.82h3.31a18.93,18.93,0,0,1,18.9,18.91v10.53A18.89,18.89,0,0,1,348.83,239l-5.05,5.07C339.87,248,336.23,248.7,331.75,250Zm6.42-47.54V241c1-.76,1-.82,6.43-6.26a12.91,12.91,0,0,0,3.78-9.11V215.13A13,13,0,0,0,338.17,202.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M189,250c-9.63-2.93-8.92-2.92-17-11a18.92,18.92,0,0,1-5.53-13.35V215.13a18.93,18.93,0,0,1,18.9-18.91h3.2C188.61,249.66,188.47,241.33,189,250Zm-6.43-47.5a12.93,12.93,0,0,0-10.1,12.6v10.53a12.86,12.86,0,0,0,3.77,9.1c5.45,5.47,5.41,5.48,6.33,6.19Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 367.15,
    y: 404.72,
    width: 6,
    height: 70.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 148.24,
    y: 404.72,
    width: 6,
    height: 70.74
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M338.17,218.1h-6v-4.76a10.93,10.93,0,0,0-10.92-10.91H277a91.94,91.94,0,0,1-60.36-22.37v5.25a16.93,16.93,0,0,1-16.91,16.91,10.93,10.93,0,0,0-10.92,10.92v5h-6V161.58a31,31,0,0,1,29.66-30.91l4.08-4.08a63.29,63.29,0,0,1,45-18.66h12.73a64,64,0,0,1,63.9,63.9ZM210.59,165.94l5.12,5.12A86,86,0,0,0,277,196.43h44.3a16.83,16.83,0,0,1,10.92,4v-28.6a58,58,0,0,0-57.9-57.9H261.54a57.28,57.28,0,0,0-40.79,16.9l-5.82,5.82h-1.24a25,25,0,0,0-24.93,24.93v38.65a16.83,16.83,0,0,1,10.92-4,10.92,10.92,0,0,0,10.91-10.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M185.76,218.1v-5a13.92,13.92,0,0,1,13.92-13.92,13.91,13.91,0,0,0,13.91-13.91V173.18A89.61,89.61,0,0,0,277,199.43h44.3a13.92,13.92,0,0,1,13.92,13.91V171.83a60.91,60.91,0,0,0-60.9-60.9H261.54a60.68,60.68,0,0,0-42.91,17.78l-4.94,4.94a27.93,27.93,0,0,0-27.93,27.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.69,355.15V285A12.67,12.67,0,0,0,252,272.86c-5.29-1.72-9.67-3.36-16.91-3.36h-9a12.56,12.56,0,0,0-12.4,12.7v22.38a8.38,8.38,0,1,0-16.75,0v28.13a14.76,14.76,0,0,0,4.21,10.37l16.76,17c-66.34,114.72-66.81,115.35-66.7,115.35h71.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M260.69,355.15V285a12.68,12.68,0,0,1,8.66-12.11c5.29-1.72,9.67-3.36,16.9-3.36h9a12.55,12.55,0,0,1,12.4,12.7v22.38a8.38,8.38,0,1,1,16.76,0v28.13a14.77,14.77,0,0,1-4.22,10.37l-16.75,17C371,477,370.05,475.46,370.15,475.46H299.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M153.83,477l-5.19-3L214.2,360.59,199,345.19A17.94,17.94,0,0,1,194,332.71V304.58a11.39,11.39,0,0,1,16.75-10.2V282.2a15.57,15.57,0,0,1,15.4-15.7c13.83,0,14.66-.45,26.84,3.51a15.61,15.61,0,0,1,10.73,15v70.64l-37.9,120.75-5.72-1.8,37.62-119.87V285a9.64,9.64,0,0,0-6.58-9.26L247,274.38c-7.18-2.33-12.1-1.88-20.88-1.88a9.57,9.57,0,0,0-9.4,9.7v37.26h-6V304.58a5.38,5.38,0,1,0-10.75,0v28.13a11.88,11.88,0,0,0,3.35,8.27l18.36,18.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M367.55,477,299.71,359.64,318.06,341a11.84,11.84,0,0,0,3.36-8.27V304.58a5.38,5.38,0,1,0-10.76,0v14.88h-6V282.2a9.56,9.56,0,0,0-9.4-9.7c-14.66,0-14.28-.26-25,3.21a9.65,9.65,0,0,0-6.58,9.26v69.71l38.7,119.86-5.71,1.84-39-120.76V285a15.61,15.61,0,0,1,10.73-15c12.06-3.92,12.58-3.51,26.84-3.51a15.57,15.57,0,0,1,15.4,15.7v12.18a11.4,11.4,0,0,1,16.76,10.2v28.13a17.91,17.91,0,0,1-5.08,12.48l-15.15,15.4L372.75,474Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M468.08,126.3c-10.25,32.81-49.23,46.17-77.44,27.3l-23.29,7.85,8.42-23.09a51.3,51.3,0,1,1,92.31-12.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M362.39,166.28l10.07-27.59a54.29,54.29,0,1,1,17.77,18.22Zm28.7-16,1.22.83a48.31,48.31,0,1,0-14-14.36l.79,1.24-6.8,18.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M132.3,85.9A33.31,33.31,0,0,1,150,136.15l5.09,15.12-15-5.47a33.29,33.29,0,1,1-7.83-59.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M160,156.23l-19.5-7.12a36.28,36.28,0,1,1,12.87-12.55ZM122.32,87.38a30.26,30.26,0,0,0-30.27,29.91c-.3,24.19,26.44,38.67,46.47,26l1.25-.79,10.51,3.83-3.58-10.6.83-1.23C160.83,114.59,146.65,87.38,122.32,87.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M62.66,222.52c29.46-15.44,65.27,2.1,71.66,34.3l21.3,10.57-21.56,10a49.64,49.64,0,1,1-71.4-54.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M85.63,319.15a52.63,52.63,0,1,1,.66-105.26,52.85,52.85,0,0,1,50.65,40.88l25.61,12.7-25.91,12.06A52.88,52.88,0,0,1,85.63,319.15Zm0-99.26a46.63,46.63,0,1,0,45.51,56.88l.32-1.44,17.25-8-17-8.45-.29-1.45A46.81,46.81,0,0,0,85.62,219.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M438.73,291.92a33.36,33.36,0,0,1-48.13-23l-14.3-7.1,14.48-6.74a33.33,33.33,0,1,1,48,36.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M423.3,298.71A36.48,36.48,0,0,1,388,270.94l-18.62-9.23,18.84-8.77a36.33,36.33,0,1,1,35.09,45.77Zm-40.08-36.83,10,5,.29,1.45a30.34,30.34,0,1,0,.16-12.6l-.33,1.44Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "427.4 77.16 393.84 117.44 417.59 117.44 406.93 144.65 442.53 104.36 417.59 104.36 427.4 77.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "126.62 97.94 106.19 122.45 120.64 122.45 114.16 139 135.82 114.49 120.64 114.49 126.62 97.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "417.6 245.11 417.6 256.51 419.87 266.48 426.87 266.48 429.19 256.51 429.19 245.11 417.6 245.11"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 418.74,
    y: 272.31,
    width: 9.31,
    height: 9.31
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "76.91 234.79 76.91 256.39 80.22 275.27 90.41 275.27 93.77 256.39 93.77 234.79 76.91 234.79"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 78.57,
    y: 283.76,
    width: 13.55,
    height: 13.55
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 352.79,
    y: 50.1,
    width: 6,
    height: 19.45,
    transform: "translate(61.9 269.09) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 333.02,
    y: 79.73,
    width: 19.45,
    height: 6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 374.52,
    y: 36.54,
    width: 6,
    height: 19.45
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M437.31,315.27l-1.49-5.81a48.09,48.09,0,0,0,5.38-1.72l2.16,5.6A53.19,53.19,0,0,1,437.31,315.27Zm15.49-6.64-3.17-5.09a49.32,49.32,0,0,0,4.62-3.26L458,305A54.87,54.87,0,0,1,452.8,308.63Zm12.78-11L461,293.75a51.22,51.22,0,0,0,3.43-4.49l5,3.37A55,55,0,0,1,465.58,297.66Zm8.93-14.27L469,281a48,48,0,0,0,1.94-5.3l5.74,1.73A53.64,53.64,0,0,1,474.51,283.39Zm4.24-16.31-6-.6a44.3,44.3,0,0,0,.22-5.69h6A49.74,49.74,0,0,1,478.75,267.08Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnxiety);
export default __webpack_public_path__ + "static/media/Anxiety.168348d4e62e4070cbc2cd7b290bf518.svg";
export { ForwardRef as ReactComponent };